<template>
  <div class="product_info_wrapper">
    <product-info-top
        :product="product"
        :color_id.sync="color_id"
        @setShowSizeModal="show_size_modal = true"
    />
    <product-info-bottom :product="product"></product-info-bottom>
    <SizeImagesModal
        v-if="product"
        :images="product.size_images"
        v-model="show_size_modal"
    />
    <products-carousel
      :items="analogues" v-if="analogues && analogues.length > 0"
      :show_price="user && user.id"
    >
      <template #title>Похожие товары на {{product.name}} ({{product.vendor_code}})</template>
    </products-carousel>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import ProductInfoTop from '../../components/modules/ProductInfo/ProductInfoTop'
import ProductInfoBottom from '../../components/modules/ProductInfo/ProductInfoBottom'
import SizeImagesModal from '../../components/Product/SizeImagesModal'
import ProductsCarousel from '@/components/modules/ProductsCarousel/ProductsCarousel.vue'
export default {
  name: 'ProductPage',
  metaInfo () {
    return {
      title: !this.product ? 'Loading...' : this.product.name
    }
  },
  data () {
    return {
      color_id: null,
      show_size_modal: false,
      analogues: []
    }
  },
  pageClass: 'product-page',
  components: {
    ProductsCarousel,
    SizeImagesModal,
    ProductInfoTop,
    ProductInfoBottom
  },
  computed: {
    ...mapState('products', ['product']),
    ...mapState('auth', ['user'])
  },
  watch: {
    $route: {
      immediate: true,
      handler (val) {
        this.color_id = parseInt(this.$route.query.color_id)
        if (this.product && this.$route.params.id !== this.product.id) {
          this.getAnalogues(this.$route.params.id).then(response => {
            this.analogues = response.data
          })
        }
      }
    },
    color_id: {
      handler (val, old) {
        if (old && val !== old) {
          this.setColorId(parseInt(val))
          this.$router.push({ query: { ...this.$route.query, color_id: parseInt(val) } })
        }
      }
    }
  },
  methods: {
    ...mapActions('products', ['getProduct', 'getAnalogues']),
    ...mapMutations('products', ['setColorId']),
    prepare () {
      console.log('color', parseInt(this.$route.query.color_id))
      this.setColorId(parseInt(this.$route.query.color_id))
      this.getAnalogues(this.$route.params.id).then(response => {
        this.analogues = response.data
      })
      this.getProduct(this.$route.params.id)
      this.$nextTick(() => {
        if (this.$route.query.color_id) {
          this.color_id = parseInt(this.$route.query.color_id)
        }
      })
    }
  },
  created () {
    this.prepare()
  },
  beforeRouteUpdate (to, from, next) {
    this.getProduct(to.params.id)
    next()
  }
}
</script>

<style scoped>

</style>
